import React, { useState } from "react";
import {
  Box,
  Button,
  Checkbox,
  Divider,
  FormControlLabel,
  FormGroup,
  IconButton,
  Modal,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { openRecipePreview } from "./RecipePreview";

const RecipePreviewModal = ({
  isOpen,
  toggleModalOpen,
  recipe,
  productLibraryMap,
  currencySymbol,
  locale,
  currency,
}) => {
  const [options, setOptions] = useState({
    showCostingInfo: true,
    showLaborInfo: true,
    showIngredients: true,
    showTrainingDetails: true,
  });

  const handleOptionChange = (option) => {
    setOptions((prev) => ({
      ...prev,
      [option]: !prev[option],
    }));
  };

  const handlePreview = () => {
    openRecipePreview({
      recipe,
      productLibraryMap,
      currencySymbol,
      locale,
      currency,
      options,
    });
    toggleModalOpen(false);
  };

  const modalStyle = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    bgcolor: "background.paper",
    borderRadius: 2,
    boxShadow: 24,
    p: 4,
  };

  return (
    <Modal
      open={isOpen}
      onClose={() => toggleModalOpen(false)}
      aria-labelledby="recipe-preview-modal"
    >
      <Box sx={modalStyle}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: 3,
          }}
        >
          <Typography variant="h4">Preview Options</Typography>
          <IconButton size="small" onClick={() => toggleModalOpen(false)}>
            <CloseIcon fontSize="small" />
          </IconButton>
        </Box>
        <Typography
          variant="body2"
          sx={{ marginBottom: 4, color: "text.secondary" }}
        >
          Select which sections to include in the recipe preview:
        </Typography>
        <FormGroup
          sx={{
            marginBottom: 3,
            border: "1px solid",
            borderColor: "divider",
            borderRadius: 1,
          }}
        >
          {[
            { key: "showCostingInfo", label: "Costing Info" },
            { key: "showLaborInfo", label: "Labor Information" },
            { key: "showIngredients", label: "Ingredients Table" },
            { key: "showTrainingDetails", label: "Training Details" },
          ].map(({ key, label }, index, arr) => (
            <React.Fragment key={key}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={options[key]}
                    onChange={() => handleOptionChange(key)}
                  />
                }
                label={label}
                sx={{ margin: 0, px: 1.5, py: 0.5 }}
              />
              {index < arr.length - 1 && <Divider />}
            </React.Fragment>
          ))}
        </FormGroup>
        <Button
          sx={{ marginTop: 2, marginBottom: 2 }}
          variant="contained"
          onClick={handlePreview}
          fullWidth
        >
          <Typography variant="largeButton">Open Preview</Typography>
        </Button>
      </Box>
    </Modal>
  );
};

export default RecipePreviewModal;
